import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";
import { MARSH_MCLENNAN_URL, OLIVER_WYMAN_URL } from "@util/constant";

/**
 * Component to render Oliver Wyman section on Partners page
 */
const OliverWymanSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="oliver-wyman-section-component">
      <AccordionV2
        testId="oliver-wyman"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader title="OliverWyman" className="px-0" />
        }
        arrowClassName="h-auto w-auto -rotate-90 border-none"
        isArrowRight
      >
        <div className="px-6 pb-2 pt-6">
          <p>
            Oliver Wyman is a global leader in management consulting. With
            offices in more than 70 cities across 30 countries, Oliver Wyman
            combines deep industry knowledge with specialized expertise in
            strategy, operations, risk management, and organization
            transformation.
          </p>

          <p>
            The firm has more than 6,000 professionals around the world who work
            with clients to optimize their business, improve their operations
            and risk profile, and accelerate their organizational performance to
            seize the most attractive opportunities. Oliver Wyman is a business
            of&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={MARSH_MCLENNAN_URL}
              target="_blank"
              rel="noreferrer"
            >
              Marsh McLennan
            </a>
            &nbsp;[NYSE: MMC].
          </p>

          <p>
            For more information, visit&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={OLIVER_WYMAN_URL}
              target="_blank"
              rel="noreferrer"
            >
              www.oliverwyman.com
            </a>
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default OliverWymanSection;
